import { render } from "./service-detail.vue?vue&type=template&id=70839224"
import script from "./service-detail.vue?vue&type=script&lang=js"
export * from "./service-detail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__